import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function PlanPhaseIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 17.25V8.75C5 7.23122 6.23122 6 7.75 6H9C9.41421 6 9.75 6.33579 9.75 6.75C9.75 7.16421 9.41421 7.5 9 7.5H7.75C7.05964 7.5 6.5 8.05964 6.5 8.75V17.25C6.5 17.9404 7.05964 18.5 7.75 18.5H16.25C16.9404 18.5 17.5 17.9404 17.5 17.25V8.75C17.5 8.05964 16.9404 7.5 16.25 7.5H15C14.5858 7.5 14.25 7.16421 14.25 6.75C14.25 6.33579 14.5858 6 15 6H16.25C17.7688 6 19 7.23122 19 8.75V17.25C19 18.7688 17.7688 20 16.25 20H7.75C6.23122 20 5 18.7688 5 17.25Z"
        fill="currentColor"
      />
      <path
        d="M14.25 5.75C14.25 5.61192 14.1381 5.5 14 5.5H10C9.86193 5.5 9.75 5.61193 9.75 5.75V7.25C9.75 7.38807 9.86193 7.5 10 7.5H14C14.1381 7.5 14.25 7.38808 14.25 7.25V5.75ZM15.75 7.25C15.75 8.21648 14.9665 9 14 9H10C9.03351 9 8.25 8.21649 8.25 7.25V5.75C8.25 4.78351 9.03351 4 10 4H14C14.9665 4 15.75 4.78352 15.75 5.75V7.25Z"
        fill="currentColor"
      />
      <path
        d="M14.25 11.5C14.6642 11.5 15 11.8358 15 12.25C15 12.6642 14.6642 13 14.25 13H9.75C9.33579 13 9 12.6642 9 12.25C9 11.8358 9.33579 11.5 9.75 11.5H14.25Z"
        fill="currentColor"
      />
      <path
        d="M14.25 14.5C14.6642 14.5 15 14.8358 15 15.25C15 15.6642 14.6642 16 14.25 16H9.75C9.33579 16 9 15.6642 9 15.25C9 14.8358 9.33579 14.5 9.75 14.5H14.25Z"
        fill="currentColor"
      />
    </svg>
  );
};
